import React from 'react'
import styled from 'styled-components'
import RoomCard from '../../components/RoomCard/RoomCard'
import {useViewFetch} from '../../utils/fetch'
import {fetchAvailableRoomsByFloorWithRoomInfo} from '../../api/reservations'
import {getRoomSearchParams} from '../../utils/recurrence'
import Spinner from '../../components/Spinner/Spinner'
import {useMeetingState} from '../../context/MeetingContext'

const MeetingSpacesList = ({activeFloor, onMeetingSelect, recurrence}) => {
  const {search} = useMeetingState()
  const {blId, flId} = activeFloor
  const params = getRoomSearchParams({
    searchFilter: search,
    recurrence,
    blId,
    flId
  })

  const {data: availableRooms, isLoading} = useViewFetch({
    api: fetchAvailableRoomsByFloorWithRoomInfo,
    parameters: params,
    onChangeOf: [activeFloor, search, recurrence]
  })

  return (
    <Container>
      {isLoading ? (
        <SpinnerContainer>
          <Spinner color="#3395fe" />
        </SpinnerContainer>
      ) : (
        <MeetingSpacesContainer>
          {availableRooms.map((room, idx) => (
            <RoomCard key={idx} room={room} onClick={onMeetingSelect} />
          ))}
        </MeetingSpacesContainer>
      )}
    </Container>
  )
}

export default MeetingSpacesList

const Container = styled.div`
  height: calc(100vh - 80px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    height: calc(100vh - 198px);
  }
`

const MeetingSpacesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  flex: 1;
  flex-wrap: wrap;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: #eff0f3;
  padding: 22px 24px 50px 50px;

  @media (max-width: 768px) {
    padding: 10px 8px 50px 10px;
  }
`

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`
